import { useState } from "react";
import { getConversationId, TGetConversationIdErrorData } from "api";
import axios from "axios";

const LOCAL_STORAGE_CONVERSATION_ID_KEY = 'LOCAL_STORAGE_CONVERSATION_ID_KEY'
export const useGetConversationId = (localStorageKey = LOCAL_STORAGE_CONVERSATION_ID_KEY) => {
  const [conversationId, setConversationId] = useState<string>('')
  const [error, setError] = useState<TGetConversationIdErrorData | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const getErrorMessage = (code: TGetConversationIdErrorData['status']) => {
    return `${code}`
  }

  const handleError = (error: unknown) => {
    const status = axios.isAxiosError(error) && error.response ? error.response.status : 204
    setError({
      status,
      message: getErrorMessage(status)
    })
  }

  const fetchCurrentConversationId = async () => {
    setError(null)
    setIsLoading(true)
    let conversationId = localStorage.getItem(localStorageKey) || ''
    if (!conversationId) {
      try {
        const { data } = await getConversationId()
        conversationId = data.conversationId
        localStorage.setItem(localStorageKey, conversationId)
      } catch (error: unknown) {
        handleError(error)
      } finally {
        setIsLoading(false)
      }
    }

    setConversationId(conversationId)
  }

  const resetConversationId = (conversationId: string = '') => {
    if (conversationId) {
      localStorage.setItem(localStorageKey, conversationId)
    } else {
      localStorage.removeItem(localStorageKey)
    }
    void fetchCurrentConversationId()
  }

  return {
    conversationId,
    conversationIdErrorData: error,
    isConversationIdLoading: isLoading,
    fetchCurrentConversationId,
    resetConversationId
  }
}